import React from "react"
import Link from "./link"
import Menu from "./menu"
import {SecondaryLinks} from "./menu"
import ScrollToTop from "./scrollToTop"
import Socials from "../components/socials"
import Spacer from "../components/spacer"

const Footer = () => {
  return (
    <>
      <footer className='colophon p40 pb20 bg-yellow'>
        <div className='ml60 m-m0'>
          <div className='flex mt40 m-flex-column'>
            <div className='w-50 flex m-100 pos-rel m-mb60 flex-wrap'>
              <ScrollToTop className='m-show m-mt40' />
              <Link to='/'>
                <div className='logo--footer m-hide' />
              </Link>
              <div className='address mta small w-100 m-hide'> 
                <a className='link ul-link light' href='https://www.google.com/maps/place/14A+Marine+Parade,+Coolangatta+QLD+4225' target='_blank' rel='noreferrer'>Marine Parade, Kirra Beach</a>
              </div>
            </div>
            <Spacer className='m-show m-mb40' />
            <div className='w-50 pos-rel m-100'>
              <Menu footer={true} />
              <ScrollToTop className='m-hide' />
              <Spacer />
              <Socials />
            </div>
          </div>
        </div>
        <Spacer className='m-mb40' />
        <BottomBar />
      </footer>
    </>
  )
}

export default Footer

export const FooterAlt = () => {
  return (
    <>
      <footer className='colophon p40 pb20 bg-teal'>
        <div className='ml60 m-m0'>
          <div className='flex mt40 m-flex-column'>
            <div className='w-50 flex m-100 pos-rel m-mb60 flex-wrap'>
              <ScrollToTop className='m-show m-mt40' />
              <Link to='/'>
                <div className='logo--footer-alt m-hide' />
              </Link>
              <div className='address mta small w-100 m-hide'> 
                <p>4 Miles Street, Kirra, QLD 4225 </p>
                <a className='link' href='tel:(07) 5690 5000'>(07) 5690 5000</a>
                <p><a className='link' href='mailto:reservations@kirrapoint.com.au'>reservations@kirrapoint.com.au</a></p>
              </div>
            </div>
            <Spacer className='m-show m-mb40' />
            <div className='w-50 pos-rel m-100'>
              <SecondaryLinks />
              <ScrollToTop className='m-hide' />
              <Spacer />
              <Socials alt={true} />
            </div>
          </div>
        </div>
        <Spacer className='m-mb40' />
        <BottomBar />
      </footer>
    </>
  )
}

const BottomBar = () => {
  return (
    <div className='ml60 m-m0'>
      <div className='ma flex small'>
        <div className='w-50 m-hide'>
          <p className='m0 op-50'>Copyright © KTQ {new Date().getFullYear()}</p>
        </div>
        <div className='w-50 flex m-100 m-space-between'>
          <p className='m0'>
            <span className='m-op4'><span className='op-50'>A development by </span></span>
            <a href='https://ktqgroup.com.au' target='_blank' rel='noreferrer' aria-label='ktq'>
              <span className='ktq' />
            </a>
          </p>
          <p className='m0 mla'>
            <span className='m-op4'><span className='op-50'>site by</span></span>{" "}
            <a href='https://bymanifesto.com' target='_blank' rel='noreferrer' aria-label='manifesto'>
              <span className='manifesto' />
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
